<template>
    <Layout>
      <div class="row">
        <div class="col-12">
                <div class="row">
                  <div class="col-md-4">
                    <div class="card">
                    <div class="card-header bg-primary rounded-1 text-white"><div v-html="theservice"></div></div>
                    <div class="card-body p-3">
                      <div class=" mb-2 d-flex justify-content-between">
                        <img class="img-rounded" src="@/assets/images/sick.png" height="70px" />
                        <span><a @click="$router.go(-1)" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-undo"></i> back</a></span>
                      </div>
                      <span v-if="patientspinner==false">
                      <table v-for="item in patients" :key="item.id" class="table">
                      <tr><td>Full Name </td><td> <b class="text-primary h7">{{ item.name }} </b></td></tr>
                      <tr><td>Gender </td><td> <span class="text-primary h7">{{ item.gender }} </span></td></tr>
                      <tr><td> Telephone </td><td> <span class="text-primary h7">0{{ item.telephone }} </span></td></tr>
                      <tr><td> Date of Birth </td><td> <span class="text-primary h7">{{ item.date_of_birth }} </span></td></tr>
                      <tr><td> Email Address </td><td> <span class="text-primary h7">{{ item.email }} </span></td></tr>
                      <tr><td> Address </td><td> <span class="text-primary h7">{{ item.address }} </span></td></tr>
                      <tr><td> Nationality </td><td> <span class="text-primary h7">{{ item.nationality }} </span></td></tr>
                      </table>
                      </span>
                      <span v-else>
                        <i class="fas fa-spinner fa-3x p-5 text-primary fa-spin"></i> 
                      </span>
                    </div>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <b-tabs pills nav-class="p-0" content-class="text-dark">
                      <b-tab active class="border-0">
                        <template v-slot:title>Diagnosis</template>
                        <div class="card">
                          <div class="card-body">
                              <h5 class="text-primary">Services</h5>
                              <table class="table table-sm mt-2" style="color: black;" density="compact">
                              <thead><tr><th>Category</th><th>Service Name</th><th>Service Price</th></tr></thead>
                              <tbody>
                                <tr v-for="item in services" :key="item.id">
                                    <td>{{ item.service_category.name }} </td>
                                    <td>{{ item.service_name.name }}</td>
                                    <td>{{ item.service_price }}</td>
                                </tr>
                              </tbody>
                              </table>
                              <h5 class="text-primary">Provisional Diagnosis</h5>
                                <span v-for="item in diagnosis" :key="item.id">
                                  <div class="row">
                                    <div class="col-md-6">
                                      <span>Presented Complaints <span class="text-info h5" v-html="item.symptoms"></span></span>
                                      <span>History of Presented Complaints <span class="text-info h5" v-html="item.history"></span></span>
                                      <span>General Examination to Review of Systems <span class="text-info h5" v-html="item.examination"></span></span>
                                    </div>
                                    <div class="col-md-6" style="border-left: 1px solid grey;">
                                      <span>Provisional Diagnosis <span class="text-info h5" v-html="item.diagnosis"></span></span>
                                      <span>Recommendation <span class="text-info h5" v-html="item.recommedation"></span></span>
                                    </div>
                                  </div>
                                </span>
                          </div>
                        </div>
                      </b-tab>
                      <b-tab class="border-0">
                          <template v-slot:title>Presciptions</template>
                          <div class="card">
                            <div class="card-body">
                              <div class="card">
                                <table class="table table-sm" style="color: black;" density="compact">
                                <thead><tr><th>Medicine</th><th>Dosage</th><th>Note</th><th>#</th></tr></thead>
                                <tbody>
                                    <tr v-for="item in prescriptions" :key="item.id">
                                    <td>{{ item.medicine.name }} </td>
                                    <td>{{ item.dosage }}</td>
                                    <td>{{ item.note }}</td>
                                    <td>
                                      <b-button @click="give(item.medicine.id,item.medicine.name,item.dosage)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-pill"></i> </b-button>
                                    </td>
                                    </tr>
                                </tbody>
                                </table>
                                <h5 class="text-primary">Medications</h5>
                                <table class="table table-sm mt-2" style="color: black;" density="compact">
                                <thead><tr><th>Medicine</th><th>Quantity</th><th>Date/Time</th></tr></thead>
                                <tbody>
                                  <tr v-for="item in medications" :key="item.id">
                                      <td>{{ item.medicine.name }} </td>
                                      <td>{{ item.quantity }}</td>
                                      <td>{{ item.created_at }}</td>
                                  </tr>
                                </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                      </b-tab>
                      <b-tab class="border-0">
                          <template v-slot:title>Consumables</template>
                          <div class="card">
                            <div class="card-body">
                              <b-button v-b-modal.new-consumables size="sm" variant="primary"><i class="mdi mdi-plus"></i> Give Consumables</b-button>
                              <div class="card">
                                <table class="table table-sm table-bordered" style="color: black;" density="compact">
                                <thead><tr><th>Consumable</th><th>Quantity</th><th>Price</th></tr></thead>
                                <tbody>
                                    <tr v-for="item in consumables" :key="item.id">
                                    <td>{{ item.consumbale.name }} </td>
                                    <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
                                    <td>{{ item.totalprice }}</td>
                                    </tr>
                                </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
        </div>
      </div>
  
      <b-modal id="new-prescription" centered title="Give Prescription" title-class="font-18" hide-footer>
          <form @submit.prevent="addPrescription">
            <div class="form-group mb-2">
              <label>Medicine</label>
                <input v-model="pre_medicine_id" type="number" hidden class="form-control" />
                <input v-model="pre_medicine" type="text" style="background: none;" readonly class="form-control" />
              </div>
              <label>Dose</label>
                <input v-model="pre_dose" type="text" readonly style="background: none;" class="form-control" />
                <label>Quantity</label>
                <input v-model="pre_quantity" type="number" min="1" required class="form-control" />
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-prescription')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>

      <b-modal id="new-consumables" centered title="Give Consumables" title-class="font-18" hide-footer>
          <form @submit.prevent="addConsumables">
            <div class="form-group mb-2">
              <label>Consumable</label>
                <multiselect v-model="medicine" @input="FilterProductUnits" :options="products" label="name"></multiselect>
              </div>
              <label>Unit</label>
                <multiselect v-model="unit" @input="FilterPrice" :options="units" label="unit"></multiselect>
              <label>Price</label>
                <input v-model="price" type="number" readonly class="form-control" />
                <label>Quantity</label>
                <input v-model="quantity" type="number"  @input="CheckMedicine" min="1" required class="form-control" />
              <div class="form-group mb-2">
              <label>Total Amount</label>
                <input v-model="totalprice" type="number" readonly class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-consumables')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import appConfig from "@/app.config";
  import Multiselect from "vue-multiselect";
  import { productMethods, productComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Patient Treatment",
      meta: [{name: "description",content: appConfig.description,},],
    },
    components: {
      Layout,Multiselect,
    },
    data() {
      return {
        title: "Patient Treatment",
        items: [{text: "Dashboard",to: "/",},{text: "Patients",active: true,},],
        patients:[],
        services:[],
        prescriptions:[],
        consumables:[],
        patientspinner:true,
        patientid:'',
        theservice:'',
        visitid:'',
        medicine:'',
        price:'',
        quantity:'1',
        units:[],
        unit:'',
        totalprice:'',
        diagnosis:[],
        medicines:[],
        medications:[],
        pre_medicine_id:'',
        pre_medicine:'',
        pre_dose:'',
        pre_quantity:1,
      };
    },
    computed: {
        ...productComputed,
    },
    created() {
      this.fetchProducts();
      this.fetchInfo();
    },
    methods: {
      ...productMethods,
      async fetchInfo(){
        this.id=this.$route.query.id;
        let url = `/inpatientinfo/${this.id}`;
        await axios.get(url).then((response) => {
          this.patientid = response.data.patients[0].patient.patient_id;
          this.visitid = response.data.patients[0].visit_id;
          this.theservice = response.data.patients[0].diagnosis;
          this.showpatient();
          this.showtprescriptions();
          this.showtconsumables();
          this.showtmedications();
          this.showservices();
        });
      },
      give(id,medicine,dose){
      this.pre_medicine_id=id;
      this.pre_medicine=medicine;
      this.pre_dose=dose;
      this.$bvModal.show('new-prescription')
    },
      CheckMedicine(){ this.totalprice = this.price*this.quantity; },
      async FilterProductUnits(){
          let url = `/unitsbyproduct/${this.medicine.id}`;
          await axios.get(url).then((response) => {
            this.units = response.data.units;
            });
        },
        async FilterPrice(){
          let url = `/productbyunitprice/${this.unit.unit_id},${this.medicine.id}`;
          await axios.get(url).then((response) => {
            this.price = response.data.price;
            this.CheckMedicine();
            });
        },
      async showpatient(){
        let url = `/patientprofile/${this.patientid}`;
        await axios.get(url).then((response) => {
          this.patients = response.data.patients;
          this.patientspinner=false;
        });
      },
      async showservices(){
        let url = `/profileservices/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.services = response.data.visits;
        });
        let url1 = `/profilediagnosis/${this.patientid},${this.visitid}`;
        await axios.get(url1).then((response) => {
          this.diagnosis = response.data.treatments;
        });
      },
      async showtprescriptions(){
        let url = `/profileprescription/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.prescriptions = response.data.prescriptions;
        });
      },
      async showtconsumables(){
        let url = `/profileconsumables/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.consumables = response.data.consumables;
        });
      },
      async addConsumables() {
        let formData = new FormData();
        formData.append("patient_id", this.patientid);
        formData.append("visit_id", this.visitid);
        formData.append("medicine", this.medicine.id);
        formData.append("unit", this.unit.unit_id);
        formData.append("quantity", this.quantity );
        formData.append("totalprice", this.totalprice);
        let url = "/addconsumables";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.$bvModal.hide('new-consumables');
            this.showtconsumables();
            this.medicine="";
            this.quantity="";
            this.$toast.success("Patient Consumables Added");
        }
        });
      },
      async showtmedications(){
        let url = `/profilemedications/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.medications = response.data.medications;
        });
      },
      async addPrescription() {
        let formData = new FormData();
        formData.append("patient_id", this.patientid);
        formData.append("visit_id", this.visitid);
        formData.append("medicine", this.pre_medicine_id);
        formData.append("quantity", this.pre_quantity );
        let url = "/giveprescription";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.$bvModal.hide('new-prescription');
            this.showtmedications();
            this.pre_medicine="";
            this.quantity="";
            this.$toast.success("Patient Prescription Given");
        }
        });
      }
    },
  };
  </script>